import { observer } from "mobx-react";
import React from "react";
import ReactDatePicker from "react-datepicker";

import { useSurveyStore } from "../../../Stores/SurveyStore";

function DatePicker() {
    const surveyStore = useSurveyStore();

    return (
        <ReactDatePicker
            inline
            onChange={(date) => surveyStore.setMovingDate(date)}
            open={true}
            selected={surveyStore.movingDate || new Date()}
        />
    );
}

export default observer(DatePicker);
